<rt-dialog-header
  [heading]="'app.candidate.share_on_the_go.allow_access_to_candidate.heading' | translate"
/>

<rt-dialog-body rtScrollable>
  <ng-container *ngrxLet="{ offer: offer$!, accessOptionsConfigs: accessOptionsConfigs$! } as ctx">
    @for (user of data?.usersToShareWith; track trackById(i, user); let i = $index) {
      <rt-user-item
        [user]="user"
        [offer]="ctx.offer"
        [accessOptionsConfig]="ctx.accessOptionsConfigs[i]"
        (valueChanges)="onUserItemValueChanges()"
      />
    }
  </ng-container>

  <ng-container *ngrxLet="usersWithAccess$! as usersWithAccess">
    @if (usersWithAccess.length >= 1) {
      <div
        (click)="usersWithAccessOpen$.next(!usersWithAccessOpen$.value)"
        class="members-with-access"
        layout
        layout-align-items-center
        margin-top
        data-cy="share-on-the-go:members-with-access:toggle"
      >
        <rt-heading variant="subheading">
          {{
            'app.candidate.share_on_the_go.allow_access_to_candidate.count_team_members_have_access'
              | translate: { count: usersWithAccess.length }
          }}
        </rt-heading>
        <rt-icon
          [name]="(usersWithAccessOpen$ | ngrxPush) ? 'keyboard-arrow-up' : 'keyboard-arrow-down'"
        />
      </div>
    }

    @if (usersWithAccessOpen$ | ngrxPush) {
      @for (user of usersWithAccess; track trackById($index, user)) {
        <rt-user-item [user]="user" />
      }
    }
  </ng-container>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button variant="plain" (click)="cancel()">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button
    variant="primary"
    [loading]="(loading$ | ngrxPush)!"
    [disabled]="!(submitEnabled$ | ngrxPush)"
    (click)="submit()"
  >
    {{ shareOnTheGoI18n.submitBtn | translate }}
  </rt-button>
</rt-dialog-footer>
